import { TableRow } from "@carbon6/c6-frontend-design";
import type { PartRecord } from "./partsCatalog";

export type PartsTableRowClickHandler = (row: PartsTableRow) => void;

export class PartsTableRow extends TableRow implements PartRecord {
  readonly uuid: string;
  readonly name: string;
  readonly tag: string | null;
  readonly description: string | null;
  readonly created_at: string;
  readonly modified_at: string;
  private readonly rowClickHandler: PartsTableRowClickHandler | null;

  constructor(record: PartRecord, rowClickHandler: PartsTableRowClickHandler | null = null) {
    super(null);
    this.rowClickHandler = rowClickHandler;
    this.uuid = record.uuid;
    this.name = record.name;
    this.tag = record.tag;
    this.description = record.description;
    this.created_at = record.created_at;
    this.modified_at = record.modified_at;
  }

  getRowId(): string {
    return this.uuid;
  }

  // 모든 행을 표시한다. 가시성은 서버 조회가 정한다.
  canShow(): boolean {
    return true;
  }

  // 선택 UI 가 없는 목록이므로 선택 대상이 아니다.
  canSelect(): boolean {
    return false;
  }

  get isRowClickable(): boolean {
    return this.rowClickHandler !== null;
  }

  onRowClick(): void {
    this.rowClickHandler?.(this);
  }

  toRecord(): PartRecord {
    return {
      uuid: this.uuid,
      name: this.name,
      tag: this.tag,
      description: this.description,
      created_at: this.created_at,
      modified_at: this.modified_at,
    };
  }
}

export function createPartsTableRow(
  record: PartRecord,
  rowClickHandler: PartsTableRowClickHandler | null = null,
): PartsTableRow {
  return new PartsTableRow(record, rowClickHandler);
}

export function createPartsTableRows(
  records: readonly PartRecord[],
  rowClickHandler: PartsTableRowClickHandler | null = null,
): PartsTableRow[] {
  return records.map((record) => createPartsTableRow(record, rowClickHandler));
}
